"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BelowSearchBar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _inlineBanner = _interopRequireDefault(require("../../../page-header/other/inline-banner"));
var _quickLinks = _interopRequireDefault(require("./quick-links"));
var _searchResult = _interopRequireDefault(require("./search-result"));
var _spinner = _interopRequireDefault(require("../../../elements/other/spinner"));
var _useDynamicQuickLinks = _interopRequireDefault(require("../../../page-body/site-search-results/useDynamicQuickLinks"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-wdia365"
});
const ResultsSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ResultsSection",
  class: "pl-r2o57zc"
});
const Results = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Results",
  class: "pl-r11ws1kx"
});
const AITagWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AITagWrapper",
  class: "pl-aedpv5d"
});
function BelowSearchBar({
  _name,
  noResultsHeading,
  noResultsDescription,
  label,
  banner,
  value,
  step,
  list,
  isLoading,
  search,
  highlight,
  showTray,
  selectedItemIndex,
  resultsExternalPaths,
  trackingCustomProperties: customProps = {},
  aiPoweredTagText,
  ...quickLinksProps
}) {
  const {
    text,
    endpointType
  } = banner;
  const quickLinksPropsWithQuery = (0, _useDynamicQuickLinks.default)(value, quickLinksProps);
  function formatUrlString(paramValue) {
    const urlString = endpointType?.url;
    const redirectToUrl = new URL(urlString);
    const {
      searchParams
    } = redirectToUrl;
    searchParams.set('itc', 'site_search_dpp');
    searchParams.set(endpointType?.searchFieldName, paramValue);
    return redirectToUrl.href;
  }
  let dataResults = [];
  Array.isArray(list) && list.forEach(listItem => {
    if (typeof listItem === 'string') {
      dataResults.push((0, _patternLibraryUtils.applySnakeCase)(listItem));
    } else {
      listItem?.title && dataResults.push((0, _patternLibraryUtils.applySnakeCase)(listItem.title));
    }
  });
  dataResults = dataResults?.length > 0 ? dataResults.join('¬') : '';
  const trackingCustomProperties = {
    ...customProps,
    sitesearch_results: dataResults
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "below-search-bar"
  }, /*#__PURE__*/_react.default.createElement(ResultsSection, null, step === 'noResults' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_inlineBanner.default, {
    dataCy: "no-results-banner",
    verticalMargin: "none",
    headlineSize: "h5",
    headlineLineLength: 2,
    textAlign: "start",
    heading: noResultsHeading,
    description: noResultsDescription
  }), /*#__PURE__*/_react.default.createElement(_inlineBanner.default, (0, _extends2.default)({
    dataCy: "domain-banner",
    headlineSize: "h6",
    headlineLineLength: 2,
    textAlign: "start"
  }, banner, {
    ctas: [{
      text,
      href: formatUrlString(value),
      _name: `${banner._name}_cta`,
      isPromo: false,
      trackingCustomProperties: customProps
    }]
  }))), /*#__PURE__*/_react.default.createElement(Results, (0, _extends2.default)({
    "data-cy": "results",
    showTray: showTray
  }, _patternLibraryUtils.tracking.create(`sitesearch_${step}`, false, false, trackingCustomProperties)), isLoading ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg",
    _name: `${_name}_spinner_${step}`
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(AITagWrapper, null, /*#__PURE__*/_react.default.createElement(_tag.default, {
    style: {
      fontSize: '0.79rem'
    },
    text: aiPoweredTagText,
    design: "inline",
    emphasis: "info"
  })), list?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "label",
    className: "captitle"
  }, label), list && Array.isArray(list) && list.map((result, i) => {
    const isSelected = i === selectedItemIndex;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `${value}-${i}`
    }, /*#__PURE__*/_react.default.createElement(_searchResult.default, (0, _extends2.default)({
      id: `${i}`,
      result: result,
      value: value,
      step: step,
      search: search,
      resultsExternalPaths: resultsExternalPaths,
      highlight: highlight,
      style: {
        '--index': `${i}`
      },
      isSelected: isSelected,
      trackingCustomProperties: customProps
    }, result)), i < list.length - 1 ? /*#__PURE__*/_react.default.createElement("hr", null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  }))), step === 'results' && /*#__PURE__*/_react.default.createElement(_inlineBanner.default, (0, _extends2.default)({
    dataCy: "domain-banner",
    headlineSize: "h6",
    headlineLineLength: 2,
    textAlign: "start"
  }, banner, {
    ctas: [{
      text,
      href: formatUrlString(value),
      _name: `${banner._name}_cta`,
      isPromo: false,
      trackingCustomProperties: customProps
    }]
  }))), /*#__PURE__*/_react.default.createElement(_quickLinks.default, quickLinksPropsWithQuery));
}
BelowSearchBar.propTypes = {
  _name: _propTypes.default.string,
  noResultsHeading: _propTypes.default.string,
  noResultsDescription: _propTypes.default.string,
  label: _propTypes.default.string,
  banner: _propTypes.default.shape({
    ..._inlineBanner.default.propTypes,
    text: _propTypes.default.string,
    endpointType: _propTypes.default.shape({
      url: _propTypes.default.string,
      searchFieldName: _propTypes.default.string
    })
  }),
  isLoading: _propTypes.default.bool,
  resultsExternalPaths: _propTypes.default.string,
  showTray: _propTypes.default.bool,
  trackingCustomProperties: _propTypes.default.object,
  aiPoweredTagText: _propTypes.default.string,
  ..._quickLinks.default.propTypes
};